
import {Component, Prop, Vue} from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import TakipTalebiTaslak from "@/components/TakipTalebiTaslak.vue";
import Emirler from "@/components/Emirler.vue";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {MasrafEntity} from "@/entity/MasrafEntity";
import MasrafForm from "@/components/forms/MasrafForm.vue";
import HacizMasrafForm from "@/components/forms/HacizMasrafForm.vue";
import SatisMasrafForm from "@/components/forms/SatisMasrafForm.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";

@Component({
  components: {
    FormDialog,
    DeleteDialog,
    SatisMasrafForm,
    HacizMasrafForm, MasrafForm, Emirler, TakipTalebiTaslak, FormWrapper}
})

export default class SatisMasrafList extends Vue {
  @Prop() satisId !: number;
  @Prop() items!: Array<MasrafEntity>;
  @Prop() hideCloseButton!: boolean | string;

  satisMasraflari: Array<AlacakKalemiEntity> = [];
  headers = [
    {text: "Tarih", align: "start", sortable: false, value: "tarih",},
    {text: "Masraf Çeşidi", align: "start", sortable: false, value: "masraf_cesidi",},
    {text: "Tutar", value: "tutar", align: "right"},
    {text: "Masraf Türü", value: "gayri_resmi_mi"},
    {text: "Belgeli", value: "masraf_belgeli_mi"},
    {text: "İşlemler", value: "actions", sortable: false, align: 'center', width: 100},
  ];

  get isHideClose() {
    return this.hideCloseButton || this.hideCloseButton === "";
  }

  mounted(){
    this.getSatisMasraflari();
  }

  load() {
    this.$emit('load');
    this.getSatisMasraflari();
  }

  getSatisMasraflari(){
    this.$http
        .get('/api/v1/satis/' + this.satisId +'/masraf')
        .then((response: any) => {
          this.satisMasraflari = response.data;
        });
  }

}
